export { default as FooterGolf } from '@/assets/logos/bravo/footer/footer-golf.svg';
export { default as FooterRejseklubben } from '@/assets/logos/bravo/footer/footer-rejseklubben.svg';
export { default as FooterSafari } from '@/assets/logos/bravo/footer/footer-safari.svg';
export { default as LogoGolf } from '@/assets/logos/bravo/logo/logo-golf.svg';
export { default as LogoRejseklubben } from '@/assets/logos/bravo/logo/logo-rejseklubben.svg';
export { default as LogoSafari } from '@/assets/logos/bravo/logo/logo-safari.svg';
export { default as NavigationGolf } from '@/assets/logos/bravo/navigation/navigation-golf.svg';
export { default as NavigationRejseklubben } from '@/assets/logos/bravo/navigation/navigation-rejseklubben.svg';
export { default as NavigationSafari } from '@/assets/logos/bravo/navigation/navigation-safari.svg';
export { default as NoResultsGolf } from '@/assets/logos/bravo/noResults/noResults-golf.svg';
export { default as NoResultsRejseklubben } from '@/assets/logos/bravo/noResults/noResults-rejseklubben.svg';
export { default as NoResultsSafari } from '@/assets/logos/bravo/noResults/noResults-safari.svg';
export { default as PositiveGolf } from '@/assets/logos/bravo/positive/positive-golf.svg';
export { default as PositiveRejseklubben } from '@/assets/logos/bravo/positive/positive-rejseklubben.svg';
export { default as PositiveSafari } from '@/assets/logos/bravo/positive/positive-safari.svg';
export { default as NoFavoritesGolf } from '@/assets/logos/bravo/symbol/symbol-golf.svg';
export { default as SymbolGolf } from '@/assets/logos/bravo/symbol/symbol-golf.svg';
export { default as NoFavoritesRejseklubben } from '@/assets/logos/bravo/symbol/symbol-rejseklubben.svg';
export { default as SymbolRejseklubben } from '@/assets/logos/bravo/symbol/symbol-rejseklubben.svg';
export { default as NoFavoritesSafari } from '@/assets/logos/bravo/symbol/symbol-safari.svg';
export { default as SymbolSafari } from '@/assets/logos/bravo/symbol/symbol-safari.svg';
export { default as Dankort } from '@/assets/logos/dankort.svg';
export { default as Footer } from '@/assets/logos/footer.svg';
export { default as Login } from '@/assets/logos/login.svg';
export { default as Logo } from '@/assets/logos/logo.svg';
export { default as Mastercard } from '@/assets/logos/mastercard.svg';
export { default as MobilePay } from '@/assets/logos/mobilepay.svg';
export { default as Navigation } from '@/assets/logos/navigation.svg';
export { default as Negative } from '@/assets/logos/negative.svg';
export { default as NoFavorites } from '@/assets/logos/noFavorites.svg';
export { default as NoResults } from '@/assets/logos/noResults.svg';
export { default as Positive } from '@/assets/logos/positive.svg';
export { default as RejsegarantiFonden } from '@/assets/logos/rejsegaranti-fonden.svg';
export { default as Symbol } from '@/assets/logos/symbol.svg';
export { default as Travelheartfamily } from '@/assets/logos/travelheartfamily.svg';
export { default as Trustpilot } from '@/assets/logos/trustpilot.svg';
export { default as Visa } from '@/assets/logos/visa.svg';
